import map from 'lodash/map'
import { useContext } from '../Context'
import { ContentRow } from './ContentRow'
import React from 'react'
import { TextAreaInput } from '@ztechapps/webui.input'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { ShowIf } from '@ztechapps/webui.util'
import { useCheckoutContext } from '@ztechapps/order.webui'

export const CartItemPanel = () => {
  const { document, refetch } = useContext()
  const context = useCheckoutContext()
  const [message, setMessage] = context.message
  return (
    <React.Fragment>
      {map(document?.items, (content) => (
        <ContentRow key={content?._id} {...content} refetch={refetch} />
      ))}

      <ShowIf condition={document?.status === OrderStatusEnum.InCart || document?.status === OrderStatusEnum.Quotation}>
        <div className="mt-2">
          <TextAreaInput
            autoFocus={false}
            value={message}
            onChange={(e) => {
              setMessage(e?.target?.value)
            }}
            rows={6}
            placeholder="Add message to the seller. (e.g. Please start processing my order!)"
          />
        </div>
      </ShowIf>
    </React.Fragment>
  )
}
